Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var React = require('react');
var reactTransitionGroup = require('react-transition-group');
var cn = require('classnames');
var coreComponentsBaseModal = require('../base-modal');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var cn__default = /*#__PURE__*/_interopDefaultCompat(cn);

var styles = {"component":"drawer__component_1govv","customScrollbar":"drawer__customScrollbar_1govv","rightPlacement":"drawer__rightPlacement_1govv","leftPlacement":"drawer__leftPlacement_1govv","content":"drawer__content_1govv","enterRight":"drawer__enterRight_1govv","enterLeft":"drawer__enterLeft_1govv","contentEnter":"drawer__contentEnter_1govv","backdropEnter":"drawer__backdropEnter_1govv","enterActive":"drawer__enterActive_1govv","backdropEnterActive":"drawer__backdropEnterActive_1govv","backdropEnterDone":"drawer__backdropEnterDone_1govv","contentEnterActive":"drawer__contentEnterActive_1govv","exit":"drawer__exit_1govv","backdropExit":"drawer__backdropExit_1govv","contentExit":"drawer__contentExit_1govv","exitActiveRight":"drawer__exitActiveRight_1govv","exitActiveLeft":"drawer__exitActiveLeft_1govv","backdropExitActive":"drawer__backdropExitActive_1govv","backdropExitDone":"drawer__backdropExitDone_1govv","contentExitActive":"drawer__contentExitActive_1govv"};
require('./index.css');

var ANIMATION_DURATION = 600;
var DrawerContext = coreComponentsBaseModal.BaseModalContext;
var backdropProps = {
    classNames: {
        enter: styles.backdropEnter,
        appear: styles.backdropEnter,
        enterActive: styles.backdropEnterActive,
        appearActive: styles.backdropEnterActive,
        enterDone: styles.backdropEnterDone,
        appearDone: styles.backdropEnterDone,
        exit: styles.backdropExit,
        exitActive: styles.backdropExitActive,
        exitDone: styles.backdropExitDone,
    },
    timeout: ANIMATION_DURATION,
};
var contentProps = {
    classNames: {
        enter: styles.contentEnter,
        appear: styles.contentEnter,
        enterActive: styles.contentEnterActive,
        appearActive: styles.contentEnterActive,
        exit: styles.contentExit,
        exitActive: styles.contentExitActive,
    },
    timeout: ANIMATION_DURATION,
};
var Drawer = React.forwardRef(function (_a, ref) {
    var _b;
    var open = _a.open, className = _a.className, children = _a.children, contentTransitionProps = _a.contentTransitionProps, _c = _a.nativeScrollbar, nativeScrollbar = _c === void 0 ? true : _c, _d = _a.placement, placement = _d === void 0 ? 'right' : _d, restProps = tslib.__rest(_a, ["open", "className", "children", "contentTransitionProps", "nativeScrollbar", "placement"]);
    var isRightPlacement = placement === 'right';
    var isLeftPlacement = placement === 'left';
    var transitionProps = React.useMemo(function () {
        var _a, _b;
        var enterClassName = cn__default.default((_a = {},
            _a[styles.enterRight] = isRightPlacement,
            _a[styles.enterLeft] = isLeftPlacement,
            _a));
        var exitClassName = cn__default.default((_b = {},
            _b[styles.exitActiveRight] = isRightPlacement,
            _b[styles.exitActiveLeft] = isLeftPlacement,
            _b));
        return tslib.__assign({ classNames: {
                enter: enterClassName,
                appear: enterClassName,
                enterActive: styles.enterActive,
                appearActive: styles.enterActive,
                exit: styles.exit,
                exitActive: exitClassName,
            }, timeout: ANIMATION_DURATION }, restProps.transitionProps);
    }, [restProps.transitionProps, isLeftPlacement, isRightPlacement]);
    return (React__default.default.createElement(coreComponentsBaseModal.BaseModal, tslib.__assign({}, restProps, { scrollHandler: 'content', ref: ref, open: open, className: cn__default.default(styles.component, className, (_b = {},
            _b[styles.rightPlacement] = isRightPlacement,
            _b[styles.leftPlacement] = isLeftPlacement,
            _b[styles.customScrollbar] = !nativeScrollbar,
            _b)), transitionProps: transitionProps, backdropProps: tslib.__assign(tslib.__assign({}, backdropProps), restProps.backdropProps) }),
        React__default.default.createElement(reactTransitionGroup.CSSTransition, tslib.__assign({}, tslib.__assign(tslib.__assign({}, contentProps), contentTransitionProps), { appear: true, in: open }),
            React__default.default.createElement("div", { className: styles.content }, children))));
});
Drawer.displayName = 'Drawer';

exports.ANIMATION_DURATION = ANIMATION_DURATION;
exports.Drawer = Drawer;
exports.DrawerContext = DrawerContext;
